import { useImg } from "@/context/ContentContext";

/* Logo bound to the editable content key `global.logo`. */
export const LogoImage = ({ className = "h-12 w-auto" }) => {
  const src = useImg("global.logo", "/assets/logo.png");
  return <img src={src} alt="Courtage des Ducs" className={className} loading="eager" />;
};

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <LogoImage className={`${className} object-contain`} />
);

export const LogoWordmark = ({ className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <LogoImage className="h-12 md:h-14 w-auto" />
  </div>
);
